<template>
  <v-app id="inspire">
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title class="fontLao">ຈັດການປະເພດສິນຄ້າ</v-toolbar-title>
        <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider>
        
        <v-spacer></v-spacer>
               <v-text-field
          v-model="search"
          append-icon="search"
          label="ຊອກຫາ"
          single-line
          hide-details
          
        ></v-text-field>
  <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <v-btn slot="activator" color="primary" dark class="mb-2 fontLao">ເພີ່ມ</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline fontLao">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field class="fontLao"  v-model="editedItem.name" label="ຊື່ປະເພດສິນຄ້າ"></v-text-field>
                  </v-flex>
            
                </v-layout>
              </v-container>
            </v-card-text>
  
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="close" class="fontLao">ຍົກເລີກ</v-btn>
                <v-btn color="blue darken-1" flat @click.native="save" class="fontLao">ບັນທືກ</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="mydata"
        :search="search"
        :rows-per-page-items=[10,20,50,100,500]
        class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.tel }}</td>
          <td class="text-xs-center">{{ props.item.ad }}</td>
          <td class="text-xs-center px-0">
            <v-icon
              small
              class="mr-2"
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
            <v-icon
              small
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </div>
  </v-app>
</template>
<script>
import db from '@/firebase/init'
export default {
    name:'Categories',
     data: () => ({
    dialog: false,
      search: '',
    headers: [
      {
        text: 'ຊື່ປະເພດສິນຄ້າ',
        align: 'left',
        sortable: true,
        value: 'name'
      },
       { text: ' ', value: 'name', sortable: false,align: 'center' },
        { text: ' ', value: 'name', sortable: false,align: 'center' },
     { text: 'Actions', value: 'name', sortable: false,align: 'center' }
    ],
    mydata: [],
    editedIndex: -1,
    editedItem: {
      name: '',
      stt:1
    },
    defaultItem: {
      name: '',
      stt:1
    }
  }),

  computed: {
    formTitle () {
        return this.editedIndex === -1 ? 'ເພີ່ມ' : 'ແກ້ໄຂ'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
     this.initialize()
   // this.initialize()
  },

  methods: {
    initialize () {
        let tdata=[];
       let ref = db.collection('categories').where("stt","==",1).get()
        .then(snapshot => {
            snapshot.forEach(doc => {
            //console.log(doc.id, '=>', doc.data());
            let tmpdata =doc.data();
            tmpdata.id =doc.id;
            //console.log( tmpdata.id )
            tdata.push(tmpdata);
            });
            this.mydata=tdata;
        })
        .catch(err => {
          console.log('Error getting documents', err);
        });
    },

    editItem (item) {
     
       this.editedIndex = this.mydata.indexOf(item)
       this.editedItem = Object.assign({}, item)
       this.dialog = true
          console.log(item)
    },

    deleteItem (item) {
      const index = this.mydata.indexOf(item)
        if ( confirm('Are you sure you want to delete this item ('+item.name+' )?')) {
          // Delete it!
           db.collection('categories').doc(item.id).update({stt:0})
           this.mydata.splice(index, 1)
        }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
       // Object.assign(this.mydata[this.editedIndex], this.editedItem)
        let id=this.editedItem.id;
        delete this.editedItem.id;
        let ref = db.collection('categories').doc(id).update(this.editedItem)
      } else {
        let ref = db.collection('categories').add(this.editedItem)
      }
      this.initialize()
      this.close()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Categories.vue